import React, { useRef, useEffect } from 'react';
import moment from 'moment';

import { env_url, getPlayerImageBaseURL, brightcove_account_id, brightcove_account_id_nhl_clips } from './endpoints';

import { nhlTeamNameIDArrayMap } from './nhl_helpers';
import { mlbTeamNameIDArrayMap } from './mlb_helpers';
import { nbaTeamNameIDArrayMap, overrideAllStarsTeamName } from './nba_helpers';
import { wnbaTeamNameIDArrayMap } from './wnba_helpers';
import { cflTeamNameIDArrayMap } from './cfl_helpers';
import { nflTeamNameIDArrayMap } from './nfl_helpers';
import { formatLeagueName, orderSoccerLeagues } from './soccer_helpers';

import { handleError } from 'utils/js/error_helpers';
import { preserveQueryParams } from './browser_helpers';

import emptyLogo from '../../assets/images/empty_logo.svg';

// **** BELOW IS ONLY USEFUL IF WE CHANGE TO SENDING DATA DIFFS THROUGH WEB SOCKETS/AJAX ****
//
// export function isObject(item) {
//   return (item && typeof item === 'object' && !Array.isArray(item));
// }
// export function mergeDeep(target, source) {
//   let output = Object.assign({}, target);
//   if (isObject(target) && isObject(source)) {
//     Object.keys(source).forEach(key => {
//       if (isObject(source[key])) {
//         if (!(key in target))
//           Object.assign(output, { [key]: source[key] });
//         else
//           output[key] = mergeDeep(target[key], source[key]);
//       } else {
//         Object.assign(output, { [key]: source[key] });
//       }
//     });
//   }
//   return output;
// }
// /**
//  * @param  {event} ev
//  * @param  {string} league
//  */
export const imgErrPerLeague = (ev, league) => {
	ev.target.src = `${env_url}/livetracker_404_${league}.png`;
};
// helper function to check if a number has decimal points
export const hasDecimals = n => {
	return Number(n) === n && n % 1 !== 0;
};
// Helper function to sort a string (Number)
export function sortNumberText(a, b) {
	var numA = Number(a);
	var numB = Number(b);
	if (numA < numB) {
		return -1;
	}
	if (numA > numB) {
		return 1;
	}
	return 0;
}
/**
 * Replaces diacritic characters in a string
 * @param {string} s
 * @returns {string} output
 */
export const accentFold = s => {
	if (!s) {
		return '';
	}
	const accentMap = {
		À: 'A',
		Á: 'A',
		Â: 'A',
		Ä: 'A',
		Æ: 'A',
		Ã: 'A',
		Å: 'A',
		Ā: 'A',
		Ç: 'C',
		Ć: 'C',
		Č: 'C',
		È: 'E',
		É: 'E',
		Ê: 'E',
		Ë: 'E',
		Ē: 'E',
		Ė: 'E',
		Ę: 'E',
		Î: 'I',
		Ï: 'I',
		Í: 'I',
		Ī: 'I',
		Į: 'I',
		Ì: 'I',
		Ł: 'L',
		Ñ: 'N',
		Ń: 'N',
		Ô: 'O',
		Ö: 'O',
		Ò: 'O',
		Ó: 'O',
		Œ: 'O',
		Ø: 'O',
		Ō: 'O',
		Õ: 'O',
		Ś: 'S',
		Š: 'S',
		Û: 'U',
		Ü: 'U',
		Ù: 'U',
		Ú: 'U',
		Ū: 'U',
		Ÿ: 'Y',
		Ž: 'Z',
		Ź: 'Z',
		Ż: 'Z',
		à: 'a',
		á: 'a',
		â: 'a',
		ä: 'a',
		æ: 'a',
		ã: 'a',
		å: 'a',
		ā: 'a',
		ç: 'c',
		ć: 'c',
		č: 'c',
		è: 'e',
		é: 'e',
		ê: 'e',
		ë: 'e',
		ē: 'e',
		ė: 'e',
		ę: 'e',
		î: 'i',
		ï: 'i',
		í: 'i',
		ī: 'i',
		į: 'i',
		ì: 'i',
		ł: 'l',
		ñ: 'n',
		ń: 'n',
		ô: 'o',
		ö: 'o',
		ò: 'o',
		ó: 'o',
		œ: 'o',
		ø: 'o',
		ō: 'o',
		õ: 'o',
		ß: 's',
		ś: 's',
		š: 's',
		û: 'u',
		ü: 'u',
		ù: 'u',
		ú: 'u',
		ū: 'u',
		ÿ: 'y',
		ž: 'z',
		ź: 'z',
		ż: 'z',
	};
	let output = '';
	for (var i = 0; i < s.length; i++) {
		output += accentMap[s.charAt(i)] || s.charAt(i);
	}

	var additional = {
		De: /de/gi,
		"D'": /d'/gi,
	};

	Object.keys(additional).map(n => {
		output = output.replace(additional[n], n);
		return n;
	});

	return output;
};

export const removeSpecialChars = s => {
	if (!s) {
		return '';
	}
	const accentMap = {
		À: 'A',
		Á: 'A',
		Â: 'A',
		Ä: 'A',
		Æ: 'A',
		Ã: 'A',
		Å: 'A',
		Ā: 'A',
		Ç: 'C',
		Ć: 'C',
		Č: 'C',
		È: 'E',
		É: 'E',
		Ê: 'E',
		Ë: 'E',
		Ē: 'E',
		Ė: 'E',
		Ę: 'E',
		Î: 'I',
		Ï: 'I',
		Í: 'I',
		Ī: 'I',
		Į: 'I',
		Ì: 'I',
		Ł: 'L',
		Ñ: 'N',
		Ń: 'N',
		Ô: 'O',
		Ö: 'O',
		Ò: 'O',
		Ó: 'O',
		Œ: 'O',
		Ø: 'O',
		Ō: 'O',
		Õ: 'O',
		Ś: 'S',
		Š: 'S',
		Û: 'U',
		Ü: 'U',
		Ù: 'U',
		Ú: 'U',
		Ū: 'U',
		Ÿ: 'Y',
		Ž: 'Z',
		Ź: 'Z',
		Ż: 'Z',
		à: 'a',
		á: 'a',
		â: 'a',
		ä: 'a',
		æ: 'a',
		ã: 'a',
		å: 'a',
		ā: 'a',
		ç: 'c',
		ć: 'c',
		č: 'c',
		è: 'e',
		é: 'e',
		ê: 'e',
		ë: 'e',
		ē: 'e',
		ė: 'e',
		ę: 'e',
		î: 'i',
		ï: 'i',
		í: 'i',
		ī: 'i',
		į: 'i',
		ì: 'i',
		ł: 'l',
		ñ: 'n',
		ń: 'n',
		ô: 'o',
		ö: 'o',
		ò: 'o',
		ó: 'o',
		œ: 'o',
		ø: 'o',
		ō: 'o',
		õ: 'o',
		ß: 's',
		ś: 's',
		š: 's',
		û: 'u',
		ü: 'u',
		ù: 'u',
		ú: 'u',
		ū: 'u',
		ÿ: 'y',
		ž: 'z',
		ź: 'z',
		ż: 'z',
	};
	let output = '';
	for (var i = 0; i < s.length; i++) {
		output += accentMap[s.charAt(i)] || s.charAt(i);
	}

	return output;
};

export const determineRounds = league => {
	if (league === 'nhl') {
		return [
			{ label: 'All Rounds', value: '' },
			{ label: 'Round 1', value: 1 },
			{ label: 'Round 2', value: 2 },
			{ label: 'Round 3', value: 3 },
			{ label: 'Round 4', value: 4 },
			{ label: 'Round 5', value: 5 },
			{ label: 'Round 6', value: 6 },
			{ label: 'Round 7', value: 7 },
		];
	} else if (league === 'nba') {
		return [
			{ label: 'All Rounds', value: '' },
			{ label: 'Round 1', value: 1 },
			{ label: 'Round 2', value: 2 },
		];
	} else {
		return [];
	}
};

export const addComma = x => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const overrideTeamTricode = (tricode = '', id = '') => {
	let newTricode = '';
	switch (tricode.toLowerCase()) {
		case 'anh':
			newTricode = 'ANA';
			break;
		case 'cls':
			newTricode = 'CLB';
			break;
		case 'mon':
			newTricode = 'MTL';
			break;
		case 'was':
			newTricode = 'WSH';
			break;
		case 'aas':
			newTricode = 'ATL';
			break;
		case 'mas':
			newTricode = 'MET';
			break;
		case 'cas':
			newTricode = 'CEN';
			break;
		case 'pas':
			newTricode = 'PAC';
			break;
		case 'nls':
			newTricode = 'NL';
			break;
		case 'als':
			newTricode = 'AL';
			break;
		case 'az':
			newTricode = 'ARI';
			break;
		default:
			newTricode = tricode.toUpperCase();
	}

	switch (id) {
		case 29082:
			newTricode = 'HUG';
			break;
		case 5194:
			newTricode = 'MKN';
			break;
		case 5193:
			newTricode = 'MAT';
			break;
		case 29083:
			newTricode = 'MCD';
			break;
	}

	return newTricode;
};

export const defaultLeagueLogo = (imagePath = '', league) => {
	let defaultImage = '';
	switch (league) {
		case 'nhl':
			defaultImage = 'nhl';
			break;
		case 'nfl':
			defaultImage = 'nfl';
			break;
		case 'cfl':
			defaultImage = 'cfl';
			break;
		default:
			defaultImage = 'tbd';
	}
	if (defaultImage === 'tbd') {
		return `${env_url}/tbd.svg`;
	} else {
		return imagePath.replace(
			// eslint-disable-next-line
			/^(.*\/)?[^\/]*\.(png|gif|jpe?g)$/i,
			'$1' + defaultImage + '.$2'
		);
	}
};

export const delayedStatus = (status, league) => {
	let statuses = [];

	switch (league) {
		case 'mlb':
		case 'wbc':
			statuses = ['Delayed', 'Postponed', 'Suspended', 'Cancelled', 'Forfeited'];
			break;
		case 'nfl':
		case 'cfl':
			statuses = ['Delayed', 'Postponed', 'Suspended', 'Cancelled', 'Forfeited'];
			break;
		case 'nhl':
		case 'whc':
		case 'wjc':
			statuses = ['Postponed', 'Suspended', 'Cancelled', 'Delayed'];
			break;
		case 'nba':
			statuses = [
				'Postponed',
				'Suspended',
				'Forfeit by Away',
				'Forfeit by Home',
				'Forfeit by both teams',
				'Cancelled',
				'Delayed',
			];
			break;
		case 'soccer':
			statuses = ['Delayed', 'Postponed', 'Suspended', 'Cancelled', 'Forfeited'];
			break;
		default:
			return false;
	}

	for (var i = 0; i < statuses.length; ++i) {
		if (status === statuses[i]) {
			return true;
		}
	}

	return false;
};

const cleanTags = content => {
	let story_formatted = content.replace(/ text="/g, '>');
	story_formatted = story_formatted.replace(/"\/>/g, '</p>');
	return story_formatted;
};

export const formatStory = story => {
	if (story.type === 'recap' || story.type === 'preview') {
		story = story.content
			.replace(/(---)|(More AP (baseball|NBA): https:\/\/apnews.com\/tag\/(MLBbaseball|NBAbasketball))/gi, '')
			.replace('--Field Level Media', '');
		story = story.split('More AP ')[0];
	} else {
		story = story.content;
	}

	return cleanTags(story);
};

export const getSportFromLeague = league => {
	switch (league) {
		case 'mlb':
			return 'baseball';
		case 'nhl':
		case 'whc':
		case 'wjc':
		case 'wwhc':
			return 'hockey';
		case 'nba':
		case 'wnba':
		case 'nba-cup':
			return 'basketball';
		case 'nfl':
		case 'cfl':
			return 'football';
		case 'oly_mhk':
		case 'oly_whk':
		case 'oly_wbk':
		case 'oly_mbk':
		case 'oly_msoc':
		case 'oly_wsoc':
			return 'olympics';
		case 'eng_fa_cup':
		case 'mls':
		case 'premier-league':
		case 'ligue-1':
		case 'la-liga':
		case 'champions-league':
		case 'bundesliga':
		case 'serie-a':
		case 'euro':
		case 'natl':
		case 'wwc':
			return 'soccer';
		default:
			return '';
	}
};

export const getPlayerURL = (first_name = '', last_name = '', id, league_arg = false) => {
	const league = league_arg ? league_arg : window.location.pathname.split('/')[2];
	const sport = getSportFromLeague(league);
	const formatName = name => {
		// eslint-disable-next-line
		return name
			.replace(/[.',/#!$%^&*;:{}=\-_`~()]/g, '') // Remove punctuation
			.replace(/\s+/g, '-') // Replace spaces with hyphens
			.toLowerCase()
			.trim();
	};

	let perm = `/${sport}/${league}/players/${formatName(first_name)}-${formatName(last_name)}/${id}`;

	return perm;
};

/*
 * getTeamURL: returns link to the team profile page
 * @param {string} city - Team City
 * @param {string} name - Team Name
 * @return {string} - url
 */
export const getTeamURL = (city = '', name = '', league_arg = false) => {
	if (city === '' || name === '') {
		return '';
	}
	const league = league_arg ? league_arg : window.location.pathname.split('/')[2];
	const sport = getSportFromLeague(league);
	return `/${sport}/${league !== 'nba-cup' ? league : 'nba'}/teams/${city.toLowerCase()}-${name.toLowerCase()}/`
		.replace(' ', '-')
		.replace('.', '');
};

/*
 * getGameURL: returns link to the game page
 * @param {string} gameId - Game ID
 * @param {string} league - League
 * @return {string} - url
 */
export const getGameURL = (league = '', gameId = '') => {
	const sport = getSportFromLeague(league);
	return `/${sport}/${league}/games/${gameId}/`;
};

/*
 * sanitizeString: removes all special characters and converts spaces to dashes
 * @param {string} str - string to be sanitized
 * @return {string} - sanitized string
 */
export const sanitizeString = str => {
	return str
		.replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, '')
		.replace(/ /g, '-')
		.toLowerCase();
};

/*
 * statsSeeAll: Returns link to the players page with sorting params.
 * @param {string} season - 2017, 2018, ...
 * @param {string} seasonType - 'post', 'reg', 'pre'
 * @param {string} tab - page tab that the link should land on
 * @return {string} url
 */
export const statsSeeAll = (season, seasonType, tab, column = null, sort = null, dir = null) => {
	const league = window.location.pathname.split('/')[2];
	const sport = getSportFromLeague(league);
	return `/${sport}/${league}/players/?season=${season}&?seasonType=${seasonType}&tab=${tab}${
		column ? '&column=' + column : ''
	}${sort ? '&sort=' + sort : ''}${dir ? '&dir=' + dir : ''}`;
};

/*
 * formatStat: Format numbers based on number of decimal places, leading zeros, etc.
 * @param {string/num} data - to be formatted
 * @param {boolean} leadingZero - 0.992 (instead of .992)
 * @param {boolean} appendPlus - for Plus/Minus data
 * @return {string/num} - formatted data
 */
export const formatStat = (
	data,
	decimalPlaces = 0,
	leadingZero = true,
	appendPlus = false,
	switchSign = false,
	removeSign = false
) => {
	let newData = (+data).toFixed(decimalPlaces);
	if (!leadingZero) {
		newData = newData.replace(/^0./, '.');
	}
	if (appendPlus && newData > 0) {
		newData = '+' + newData;
	}
	if (switchSign && newData < 0) {
		newData = newData.replace(/^-/, '+');
	}
	if (removeSign) {
		newData = newData.replace(/^[+-]/, '');
	}
	return newData;
};

/*
 * overrideTeamName: Returns team city or overrides it based on the tricode.
 * @param {string} tricode - Team tricode
 * @param {string} tricode - Team city
 * @param {string} tricode - league
 * @return {string} name - Team name
 */
export const overrideTeamName = (tricode, city, league = 'nhl') => {
	tricode = tricode.toLowerCase();

	if (league === 'nhl') {
		switch (tricode) {
			case 'nyr':
				return 'NY Rangers';
			case 'nyi':
				return 'NY Islanders';
			default:
				return city;
		}
	}

	if (league === 'mlb') {
		switch (tricode) {
			case 'chc':
				return 'CHI Cubs';
			case 'cws':
				return 'CHI White Sox';
			case 'laa':
				return 'LA Angels';
			case 'lad':
				return 'LA Dodgers';
			case 'nyy':
				return 'NY Yankees';
			case 'nym':
				return 'NY Mets';
			default:
				return city;
		}
	}

	if (league === 'nba') {
		switch (tricode) {
			case 'lal':
				return 'LA Lakers';
			case 'lac':
				return 'LA Clippers';
			default:
				return city;
		}
	}

	if (league === 'nfl') {
		switch (tricode) {
			case 'nyj':
				return 'NY Jets';
			case 'nyg':
				return 'NY Giants';
			case 'lar':
				return 'LA Rams';
			case 'lac':
				return 'LA Chargers';
			default:
				return city;
		}
	}

	return city;
};

/*
 * getWeeks: Returns season type based on gameType
 * @param {string} gameType - type of a game
 * @return {string} seasonType - {pre, reg}
 * no post type games for football
 */
export const getSeasonType = gameType => {
	switch (gameType.toLowerCase()) {
		case 'regular season':
			return 'reg';
		case 'exhibition':
		case 'hall of fame week':
		case 'preseason w1':
		case 'preseason w2':
		case 'preseason w3':
			return 'pre';
		case 'first round playoffs':
		case 'second round playoffs':
		case 'division semi-finals':
		case 'conference championships':
		case 'div. championship':
		case 'pro bowl':
		case 'super bowl':
		case 'grey cup':
		case 'post season':
		case 'wild card weekend':
		case 'div.playoffs':
		case 'div.semi-finals':
		case 'div.finals':
		case 'conf.championships':
			return 'pst';
		default:
			return 'reg';
	}
};

/*
 * getWeeks: Returns football weeks for score page
 * @param {league} tricode - Team tricode
 * @return {array} weeks - {week, type, name}
 * no post type games for football
 */
export const getWeeks = (league, seasonYear = null) => {
	switch (league.toLowerCase()) {
		case 'nfl':
			if (seasonYear && parseInt(seasonYear) === 2023) {
				// Special case for 2023 season - no pro bowl
				return [
					{ week: 1, type: 'pre', name: 'Hall of Fame Week' },
					{ week: 2, type: 'pre', name: 'Preseason W1' },
					{ week: 3, type: 'pre', name: 'Preseason W2' },
					{ week: 4, type: 'pre', name: 'Preseason W3' },
					{ week: 1, type: 'reg', name: 'Week 1' },
					{ week: 2, type: 'reg', name: 'Week 2' },
					{ week: 3, type: 'reg', name: 'Week 3' },
					{ week: 4, type: 'reg', name: 'Week 4' },
					{ week: 5, type: 'reg', name: 'Week 5' },
					{ week: 6, type: 'reg', name: 'Week 6' },
					{ week: 7, type: 'reg', name: 'Week 7' },
					{ week: 8, type: 'reg', name: 'Week 8' },
					{ week: 9, type: 'reg', name: 'Week 9' },
					{ week: 10, type: 'reg', name: 'Week 10' },
					{ week: 11, type: 'reg', name: 'Week 11' },
					{ week: 12, type: 'reg', name: 'Week 12' },
					{ week: 13, type: 'reg', name: 'Week 13' },
					{ week: 14, type: 'reg', name: 'Week 14' },
					{ week: 15, type: 'reg', name: 'Week 15' },
					{ week: 16, type: 'reg', name: 'Week 16' },
					{ week: 17, type: 'reg', name: 'Week 17' },
					{ week: 18, type: 'reg', name: 'Week 18' },
					{ week: 19, type: 'reg', name: 'Wild Card Weekend' },
					{ week: 20, type: 'reg', name: 'Div. Playoffs' },
					{ week: 21, type: 'reg', name: 'Conf. Championships' },
					{ week: 23, type: 'reg', name: 'Super Bowl' },
				];
			} else if (seasonYear && parseInt(seasonYear) >= 2021) {
				// Special case for schedule change for 2021 and (likely) onwards
				return [
					{ week: 0, type: 'pre', name: 'Hall of Fame Week' },
					{ week: 1, type: 'pre', name: 'Preseason W1' },
					{ week: 2, type: 'pre', name: 'Preseason W2' },
					{ week: 3, type: 'pre', name: 'Preseason W3' },
					{ week: 1, type: 'reg', name: 'Week 1' },
					{ week: 2, type: 'reg', name: 'Week 2' },
					{ week: 3, type: 'reg', name: 'Week 3' },
					{ week: 4, type: 'reg', name: 'Week 4' },
					{ week: 5, type: 'reg', name: 'Week 5' },
					{ week: 6, type: 'reg', name: 'Week 6' },
					{ week: 7, type: 'reg', name: 'Week 7' },
					{ week: 8, type: 'reg', name: 'Week 8' },
					{ week: 9, type: 'reg', name: 'Week 9' },
					{ week: 10, type: 'reg', name: 'Week 10' },
					{ week: 11, type: 'reg', name: 'Week 11' },
					{ week: 12, type: 'reg', name: 'Week 12' },
					{ week: 13, type: 'reg', name: 'Week 13' },
					{ week: 14, type: 'reg', name: 'Week 14' },
					{ week: 15, type: 'reg', name: 'Week 15' },
					{ week: 16, type: 'reg', name: 'Week 16' },
					{ week: 17, type: 'reg', name: 'Week 17' },
					{ week: 18, type: 'reg', name: 'Week 18' },
					{ week: 1, type: 'pst', name: 'Wild Card Weekend' },
					{ week: 2, type: 'pst', name: 'Div. Playoffs' },
					{ week: 3, type: 'pst', name: 'Conf. Championships' },
					{ week: 4, type: 'pst', name: 'Super Bowl' },
				];
			} else {
				return [
					{ week: 1, type: 'pre', name: 'Hall of Fame Week' },
					{ week: 2, type: 'pre', name: 'Preseason W1' },
					{ week: 3, type: 'pre', name: 'Preseason W2' },
					{ week: 4, type: 'pre', name: 'Preseason W3' },
					{ week: 5, type: 'pre', name: 'Preseason W4' },
					{ week: 1, type: 'reg', name: 'Week 1' },
					{ week: 2, type: 'reg', name: 'Week 2' },
					{ week: 3, type: 'reg', name: 'Week 3' },
					{ week: 4, type: 'reg', name: 'Week 4' },
					{ week: 5, type: 'reg', name: 'Week 5' },
					{ week: 6, type: 'reg', name: 'Week 6' },
					{ week: 7, type: 'reg', name: 'Week 7' },
					{ week: 8, type: 'reg', name: 'Week 8' },
					{ week: 9, type: 'reg', name: 'Week 9' },
					{ week: 10, type: 'reg', name: 'Week 10' },
					{ week: 11, type: 'reg', name: 'Week 11' },
					{ week: 12, type: 'reg', name: 'Week 12' },
					{ week: 13, type: 'reg', name: 'Week 13' },
					{ week: 14, type: 'reg', name: 'Week 14' },
					{ week: 15, type: 'reg', name: 'Week 15' },
					{ week: 16, type: 'reg', name: 'Week 16' },
					{ week: 17, type: 'reg', name: 'Week 17' },
					{ week: 18, type: 'reg', name: 'Wild Card Weekend' },
					{ week: 19, type: 'reg', name: 'Div. Playoffs' },
					{ week: 20, type: 'reg', name: 'Conf. Championships' },
					{ week: 21, type: 'reg', name: 'Pro Bowl' },
					{ week: 22, type: 'reg', name: 'Super Bowl' },
				];
			}
		case 'cfl':
			//Special case for 2022 season (no exhibition W3)
			if (seasonYear && parseInt(seasonYear) === 2022) {
				return [
					{ week: 1, type: 'pre', name: 'Preseason W1' },
					{ week: 2, type: 'pre', name: 'Preseason W2' },
					{ week: 1, type: 'reg', name: 'Week 1' },
					{ week: 2, type: 'reg', name: 'Week 2' },
					{ week: 3, type: 'reg', name: 'Week 3' },
					{ week: 4, type: 'reg', name: 'Week 4' },
					{ week: 5, type: 'reg', name: 'Week 5' },
					{ week: 6, type: 'reg', name: 'Week 6' },
					{ week: 7, type: 'reg', name: 'Week 7' },
					{ week: 8, type: 'reg', name: 'Week 8' },
					{ week: 9, type: 'reg', name: 'Week 9' },
					{ week: 10, type: 'reg', name: 'Week 10' },
					{ week: 11, type: 'reg', name: 'Week 11' },
					{ week: 12, type: 'reg', name: 'Week 12' },
					{ week: 13, type: 'reg', name: 'Week 13' },
					{ week: 14, type: 'reg', name: 'Week 14' },
					{ week: 15, type: 'reg', name: 'Week 15' },
					{ week: 16, type: 'reg', name: 'Week 16' },
					{ week: 17, type: 'reg', name: 'Week 17' },
					{ week: 18, type: 'reg', name: 'Week 18' },
					{ week: 19, type: 'reg', name: 'Week 19' },
					{ week: 20, type: 'reg', name: 'Week 20' },
					{ week: 21, type: 'reg', name: 'Week 21' },
					{ week: 22, type: 'reg', name: 'Div. Semi-Finals' },
					{ week: 23, type: 'reg', name: 'Div. Finals' },
					{ week: 24, type: 'reg', name: 'Grey Cup' },
				];
			}

			// Special case for schedule change for 2021
			if (seasonYear && parseInt(seasonYear) === 2021) {
				return [
					{ week: 1, type: 'reg', name: 'Week 1' },
					{ week: 2, type: 'reg', name: 'Week 2' },
					{ week: 3, type: 'reg', name: 'Week 3' },
					{ week: 4, type: 'reg', name: 'Week 4' },
					{ week: 5, type: 'reg', name: 'Week 5' },
					{ week: 6, type: 'reg', name: 'Week 6' },
					{ week: 7, type: 'reg', name: 'Week 7' },
					{ week: 8, type: 'reg', name: 'Week 8' },
					{ week: 9, type: 'reg', name: 'Week 9' },
					{ week: 10, type: 'reg', name: 'Week 10' },
					{ week: 11, type: 'reg', name: 'Week 11' },
					{ week: 12, type: 'reg', name: 'Week 12' },
					{ week: 13, type: 'reg', name: 'Week 13' },
					{ week: 14, type: 'reg', name: 'Week 14' },
					{ week: 15, type: 'reg', name: 'Week 15' },
					{ week: 16, type: 'reg', name: 'Week 16' },
					{ week: 17, type: 'reg', name: 'Div. Semi-Finals' },
					{ week: 18, type: 'reg', name: 'Div. Finals' },
					{ week: 19, type: 'reg', name: 'Grey Cup' },
				];
			}

			return [
				{ week: 1, type: 'pre', name: 'Preseason W1' },
				{ week: 2, type: 'pre', name: 'Preseason W2' },
				{ week: 3, type: 'pre', name: 'Preseason W3' },
				{ week: 1, type: 'reg', name: 'Week 1' },
				{ week: 2, type: 'reg', name: 'Week 2' },
				{ week: 3, type: 'reg', name: 'Week 3' },
				{ week: 4, type: 'reg', name: 'Week 4' },
				{ week: 5, type: 'reg', name: 'Week 5' },
				{ week: 6, type: 'reg', name: 'Week 6' },
				{ week: 7, type: 'reg', name: 'Week 7' },
				{ week: 8, type: 'reg', name: 'Week 8' },
				{ week: 9, type: 'reg', name: 'Week 9' },
				{ week: 10, type: 'reg', name: 'Week 10' },
				{ week: 11, type: 'reg', name: 'Week 11' },
				{ week: 12, type: 'reg', name: 'Week 12' },
				{ week: 13, type: 'reg', name: 'Week 13' },
				{ week: 14, type: 'reg', name: 'Week 14' },
				{ week: 15, type: 'reg', name: 'Week 15' },
				{ week: 16, type: 'reg', name: 'Week 16' },
				{ week: 17, type: 'reg', name: 'Week 17' },
				{ week: 18, type: 'reg', name: 'Week 18' },
				{ week: 19, type: 'reg', name: 'Week 19' },
				{ week: 20, type: 'reg', name: 'Week 20' },
				{ week: 21, type: 'reg', name: 'Week 21' },
				{ week: 1, type: 'pst', name: 'Div. Semi-Finals' },
				{ week: 2, type: 'pst', name: 'Div. Finals' },
				{ week: 3, type: 'pst', name: 'Grey Cup' },
			];
		case 'ncaafb':
			return [
				{ week: 1, type: 'reg', name: 'Week 1' },
				{ week: 2, type: 'reg', name: 'Week 2' },
				{ week: 3, type: 'reg', name: 'Week 3' },
				{ week: 4, type: 'reg', name: 'Week 4' },
				{ week: 5, type: 'reg', name: 'Week 5' },
				{ week: 6, type: 'reg', name: 'Week 6' },
				{ week: 7, type: 'reg', name: 'Week 7' },
				{ week: 8, type: 'reg', name: 'Week 8' },
				{ week: 9, type: 'reg', name: 'Week 9' },
				{ week: 10, type: 'reg', name: 'Week 10' },
				{ week: 11, type: 'reg', name: 'Week 11' },
				{ week: 12, type: 'reg', name: 'Week 12' },
				{ week: 13, type: 'reg', name: 'Week 13' },
				{ week: 14, type: 'reg', name: 'Week 14' },
				{ week: 15, type: 'reg', name: 'Week 15' },
				{ week: 16, type: 'reg', name: 'Week 16' },
				{ week: 17, type: 'reg', name: 'Bowl Week 17' },
				{ week: 18, type: 'reg', name: 'Bowl Week 18' },
				{ week: 19, type: 'reg', name: 'Bowl Week 19' },
				{ week: 20, type: 'reg', name: 'Bowl Week 20' },
				{ week: 21, type: 'reg', name: 'National Championship' },
			];

		default:
			return [];
	}
};

export const ordinalSuffix = i => {
	if (!i) {
		return '';
	}

	const j = i % 10,
		k = i % 100;
	if (j === 1 && k !== 11) {
		return i + 'st';
	}
	if (j === 2 && k !== 12) {
		return i + 'nd';
	}
	if (j === 3 && k !== 13) {
		return i + 'rd';
	}
	return i + 'th';
};

export const formatMoney = (amount, decimalCount = 0, decimal = '.', thousands = ',') => {
	try {
		decimalCount = Math.abs(decimalCount);
		decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

		const negativeSign = amount < 0 ? '-' : '';

		let i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
		let j = i.length > 3 ? i.length % 3 : 0;

		return (
			negativeSign +
			(j ? i.substr(0, j) + thousands : '') +
			i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
			(decimalCount
				? decimal +
				  Math.abs(amount - i)
						.toFixed(decimalCount)
						.slice(2)
				: '')
		);
	} catch (e) {
		handleError(e);
	}
};

/**
 * getTeamNameById: Returns team name slug from the map when team id and league is provided
 * optional title formatting available by passing boolean
 * @param {number} teamId
 * @param {string} league
 * @param {boolean} title
 */

export function getTeamNameById(teamId, league, title = false) {
	let teamNameFromMap;

	const titleCase = str => {
		return str
			.split('-')
			.map(x => x[0].toUpperCase() + x.slice(1))
			.join(' ');
	};

	switch (league) {
		case 'nhl':
			nhlTeamNameIDArrayMap.forEach((teamName, id) => {
				if (id === teamId) {
					teamNameFromMap = title ? titleCase(teamName) : teamName;
				}
			});
			break;
		case 'mlb':
			mlbTeamNameIDArrayMap.forEach((teamName, id) => {
				if (id === teamId) {
					teamNameFromMap = title ? titleCase(teamName) : teamName;
				}
			});
			break;
		case 'nba':
			nbaTeamNameIDArrayMap.forEach((teamName, id) => {
				if (id === teamId) {
					teamNameFromMap = title ? titleCase(teamName) : teamName;
				}
			});
			break;
		case 'wnba':
			wnbaTeamNameIDArrayMap.forEach((teamName, id) => {
				if (id === teamId) {
					teamNameFromMap = title ? titleCase(teamName) : teamName;
				}
			});
			break;
		case 'cfl':
			cflTeamNameIDArrayMap.forEach((teamName, id) => {
				if (id === teamId) {
					teamNameFromMap = title ? titleCase(teamName) : teamName;
				}
			});
			break;
		case 'nfl':
			nflTeamNameIDArrayMap.forEach((teamName, id) => {
				if (id === teamId) {
					teamNameFromMap = title ? titleCase(teamName) : teamName;
				}
			});
			break;
		default: {
			return '';
		}
	}
	return teamNameFromMap;
}

export function numberOfdecimalPlaces(num) {
	var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
	if (!match) {
		return 0;
	}
	return Math.max(
		0,
		// Number of digits right of decimal point.
		(match[1] ? match[1].length : 0) -
			// Adjust for scientific notation.
			(match[2] ? +match[2] : 0)
	);
}

/*
 * getNestedObjValueByString: Returns nested object value based on a string reference
 * @param {object} o - initial object
 * @param {string} s - nested param reference ex. 'data.details.id'
 * @return {mixed}
 */
export function getNestedObjValueByString(o, s) {
	s = s.replace(/\[(\w+)\]/g, '.$1');
	s = s.replace(/^\./, '');
	var a = s.split('.');
	for (var i = 0, n = a.length; i < n; ++i) {
		var k = a[i];
		if (k in o) {
			o = o[k];
		} else {
			return;
		}
	}
	return o;
}

export function decodeEntities(str) {
	// https://stackoverflow.com/questions/5796718/html-entity-decode
	let element = document.createElement('div');

	if (str && typeof str === 'string') {
		// strip script/html tags
		str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '');
		str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '');
		element.innerHTML = str;
		str = element.textContent;
		element.textContent = '';
	}

	return str;
}

const playerProfileEnabled = ['mlb', 'nhl', 'nba', 'nfl'];

export const spaPlayerEnabled = league => {
	return playerProfileEnabled.includes(league);
};

export const enableSPAifUrlMatch = currentPath => playerProfileEnabled.some(x => currentPath.includes(x));

/*
 * removeTrailingSlash: remove trailing slash from strings
 * @param {string} str - string (usually URL)
 * @return {string}
 */
export const removeTrailingSlash = str => {
	if (!str) return str;
	return str.replace(/\/+$/, '');
};

/*
 * removeDomain: remove domain from URL
 * @param {string} url - url string
 * @return {string}
 */
export const removeDomain = url => {
	if (!url) return url;
	return url.replace(/^.*\/\/[^/]+/, '');
};

export const getPlayerImageURL = (id, size = 'sm', league = '') => {
	if (!id) return '';
	let size_conversions = {
		xs: 280,
		sm: 480,
		md: 780,
		lg: 1080,
	};
	return `${getPlayerImageBaseURL(league)}/${size_conversions[size]}/${id}.png`;
};

export const toTitleCase = str => {
	if (!str) return '';
	return str.replace(/\w\S*/g, function(txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
};

export const flattenObject = (ob, top_param = null) => {
	var toReturn = {};

	for (var i in ob) {
		if (!ob.hasOwnProperty(i)) continue;

		if (typeof ob[i] === 'object' && ob[i] !== null) {
			var flatObject = flattenObject(ob[i], top_param);
			let id = i;
			let index_id = '';
			let x_prefix = '';

			for (var x in flatObject) {
				if (!flatObject.hasOwnProperty(x)) continue;

				/// optinally use object param/value structure instead of index - must be top level object param!
				if (top_param && x === top_param) {
					id = top_param;
					index_id = flatObject[x];
					x_prefix = index_id + '.';
				} else {
					toReturn[id + '.' + x_prefix + x] = flatObject[x];
				}
			}
		} else {
			toReturn[i] = ob[i];
		}
	}
	return toReturn;
};

export const getScore = (homeTeam, visitingTeam, teamId) => {
	return teamId === homeTeam.id
		? homeTeam.score > visitingTeam.score
			? `W ${homeTeam.score}-${visitingTeam.score}`
			: homeTeam.score < visitingTeam.score
			? `L ${homeTeam.score}-${visitingTeam.score}`
			: `T ${homeTeam.score}-${visitingTeam.score}`
		: visitingTeam.score > homeTeam.score
		? `W ${visitingTeam.score}-${homeTeam.score}`
		: visitingTeam.score < homeTeam.score
		? `L ${visitingTeam.score}-${homeTeam.score}`
		: `T ${visitingTeam.score}-${homeTeam.score}`;
};

export const chunkArray = (array, size) => {
	let result = [];
	for (var value of array) {
		let lastArray = result[result.length - 1];
		if (!lastArray || lastArray.length === size) {
			result.push([value]);
		} else {
			lastArray.push(value);
		}
	}
	return result;
};

export const numberWithCommas = x => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatRecapVideo = (video, daysBeforeExpire) => {
	const videoDateFormatted = video.post_date ? new Date(video.post_date * 1000) : new Date();
	const daysSinceVideoCreated = (new Date().getTime() - videoDateFormatted.getTime()) / (1000 * 3600 * 24);

	if (!video || (daysBeforeExpire && daysSinceVideoCreated > daysBeforeExpire)) {
		return null;
	}

	return {
		id: video.bc_shared_id || video.bc_id,
		title: video.title,
		bcAccountId: video.bc_shared_id ? brightcove_account_id_nhl_clips : brightcove_account_id,
	};
};

export function getPlayerLink(player, customStyle = '') {
	const firstName = player.first_name ? player.first_name.charAt(0) + '.' : '';
	const lastName = player.last_name ? player.last_name : '';

	const league = window.location.pathname.split('/')[2];
	const isPlayerLinkEnabled = !['wnbaa', 'cfl', 'wbc'].includes(league);

	return (
		<>
			{isPlayerLinkEnabled ? (
				<a
					className={`player_link ${customStyle}`}
					href={preserveQueryParams(getPlayerURL(player.first_name, player.last_name, player.id || player.player_id))}
				>
					{player?.preferred_name
						? player?.preferred_name
						: player?.display_name
						? player?.display_name
						: `${firstName} ${lastName}`}
				</a>
			) : (
				<span className={`player_name ${customStyle}`}>{`${firstName} ${lastName}`}</span>
			)}
		</>
	);
}

export function getPlayerWithoutLink(player, customStyle = '') {
	let firstName = player.first_name ? player.first_name.charAt(0) + '.' : '';
	let lastName = player.last_name ? player.last_name : '';

	return <span className={`player_name ${customStyle}`}>{`${firstName} ${lastName}`}</span>;
}

export function getPlayerLinkWithPosition(player) {
	return (
		<>
			<span>{getPlayerLink(player)}</span>
			<span className='position'>{player.short_position}</span>
		</>
	);
}
export function getPlayerWithNumber(player, customStyle = {}) {
	return (
		<>
			<span style={customStyle} className={`player_name`}>
				{getPlayerWithoutLink(player)}
			</span>
			<span style={customStyle} className={`player_number`}>
				#{player.number}
			</span>
		</>
	);
}
export function getPlayerLinkWithNumberAndPosition(player, isSubstitution = false, order) {
	let customStyle = {};
	if (isSubstitution) {
		customStyle = 'substitution';
	}
	return (
		<>
			{order && <span className='player_order'>{order}</span>}
			<span>{getPlayerLink(player, customStyle)}</span>
			<span className='player_number'> #{player.number}</span>
			<span className='player_position'>{player.short_position}</span>
		</>
	);
}
export function getPlayerWithoutLinkWithNumberAndPosition(player, isSubstitution = false) {
	let customStyle = '';
	if (isSubstitution) {
		customStyle = 'substitution';
	}
	return (
		<>
			<span>{getPlayerWithoutLink(player, customStyle)}</span>
			<span className='player_number'> #{player.number}</span>
			<span className='player_position'>{player.short_position}</span>
		</>
	);
}

export function getLivetrackerImage(league, sport, type, isDarkMode) {
	const darkModeStr = isDarkMode ? '-darkmode' : '';
	// Hide Pre-Season for champions league - SNWEB-1090
	const preSeasonStr = type === 'Pre-Season' && league !== 'champions-league' ? '-ps' : '';

	if (league.includes('oly')) {
		return `${env_url}/header-olympics-lt.png`;
	}

	if (sport !== 'soccer') {
		return `${env_url}/lt-logos/header-${league}-lt${darkModeStr}${preSeasonStr}.svg`;
	} else if (sport === 'soccer') {
		return `${env_url}/lt-logos/header-soccer-lt${preSeasonStr}.svg`;
	}
}

export function getTeamLogo(
	data,
	enableDarkMode,
	fallbackNode = 'image_url',
	logoVariantsNode = 'logo_variants',
	logoSize = 'medium',
	defaultLogo = ''
) {
	if (!data) return '';

	const logoVariants = data[logoVariantsNode];

	if (logoVariants?.light_mode[logoSize]) {
		return enableDarkMode && logoVariants?.dark_mode[logoSize]
			? logoVariants.dark_mode[logoSize]
			: logoVariants?.light_mode[logoSize] || '';
	}

	if (Array.isArray(fallbackNode)) {
		for (const node of fallbackNode) {
			if (data[node]) {
				return data[node];
			}
		}
	} else if (data[fallbackNode]) {
		return data[fallbackNode];
	}

	return defaultLogo !== '' ? defaultLogo : emptyLogo;
}

export function formatGamesByLeague(games = [], sport) {
	let gamesByLeague = {};
	let gamesArray = [];
	games.forEach(game => {
		if (!gamesByLeague[game.league]) {
			gamesByLeague[game.league] = [];
		}
		gamesByLeague[game.league].push(game);
	});

	if (sport === 'soccer') {
		gamesByLeague = orderSoccerLeagues(gamesByLeague);
	}

	for (const league in gamesByLeague) {
		gamesArray.push({ leagueTitle: formatLeagueName(league) }, ...gamesByLeague[league]);
	}

	return gamesArray;
}

export function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatNumberWithDecimal(number, decimalPlaces = 0) {
	return number.toFixed(decimalPlaces);
}

export function getBroadcastURL(channelName) {
	switch (channelName) {
		case 'sn':
		case 'sno':
			return 'https://watch.sportsnet.ca/channel/SN_Ontario_24533';
		case 'sne':
			return 'https://watch.sportsnet.ca/channel/SN_East_24466';
		case 'snw':
			return 'https://watch.sportsnet.ca/channel/SN_West_24468';
		case 'snp':
			return 'https://watch.sportsnet.ca/channel/SN_Pacific_24530';
		case 'sn1':
			return 'https://watch.sportsnet.ca/channel/SN_One_24469';
		case 'sn360':
			return 'https://watch.sportsnet.ca/channel/SN_360_24467';
		case 'snwl':
		case 'sn world':
			return 'https://watch.sportsnet.ca/channel/SN_World_5895';
		case 'sn now+':
			return 'https://watch.sportsnet.ca';
		case 'Sportsnet+ Premium':
			return 'https://watch.sportsnet.ca';
		default:
			return '';
	}
}

export function getBroadcastShortName(channelName = '') {
	switch (channelName) {
		case 'sn':
			return 'SN';
		case 'sno':
			return 'SNO';
		case 'sne':
			return 'SNE';
		case 'snw':
			return 'SNW';
		case 'snp':
			return 'SNP';
		case 'sn1':
			return 'SN1';
		case 'sn360':
			return 'SN360';
		case 'snwl':
		case 'sn world':
			return 'SNWL';
		case 'sn now':
		case 'SN NOW':
		case 'Sportsnet+':
			return 'SN+';
		case 'sn now+':
		case 'Sportsnet+ Premium':
		case 'SN NOW+':
			return 'Sportsnet+';
		case 'sn oil':
			return 'SN Oil';
		case 'sn fla':
			return 'SN FLA';
		case 'sn canucks':
			return 'SN CANUCKS';
		case 'city':
			return 'City';
		case 'cbc':
			return 'CBC';
		case 'aptn':
			return 'APTN';
		default:
			return channelName.toUpperCase();
	}
}

export function getBroadcastString(channelName) {
	if (channelName) {
		return `Stream on Sportsnet+`.toUpperCase();
	}
}

export function defaultSort(a = null, b = null) {
	if (a < b) {
		return -1;
	}
	if (a > b) {
		return 1;
	}
	return 0;
}

export function calculatePercentage(num = 0, total = 0, decimalPlaces = 0) {
	const percent = ((num / total) * 100).toFixed(decimalPlaces);
	if (percent === 'NaN') {
		return (0).toFixed(decimalPlaces);
	}
	if (percent === 'Infinity') {
		return (100).toFixed(decimalPlaces);
	}
	return percent;
}

export function formatHockeyGameRecord(gametype = '', teamData = {}, league = '') {
	let record = '';
	if (league === 'ohl' || league === 'whl' || league === 'qmjhl' || league === 'ahl') {
		record =
			(teamData.season_stats.wins ? teamData.season_stats.wins : 0) +
			'-' +
			(teamData.season_stats.losses ? teamData.season_stats.losses : 0);
		if (gametype.includes('Regular Season')) {
			record =
				record +
				'-' +
				(teamData.season_stats.overtime_losses ? teamData.season_stats.overtime_losses : 0) +
				'-' +
				(teamData.season_stats.shootout_losses ? teamData.season_stats.shootout_losses : 0);
		}
	}
	if (league === 'chl') {
		record =
			(teamData.season_stats.wins ? teamData.season_stats.wins : 0) +
			'-' +
			(teamData.season_stats.overtime_wins ? teamData.season_stats.overtime_wins : 0) +
			'-' +
			(teamData.season_stats.overtime_losses ? teamData.season_stats.overtime_losses : 0) +
			'-' +
			(teamData.season_stats.losses ? teamData.season_stats.losses : 0);
	}
	return record;
}

export function formatGameTeamDetails(game = {}) {
	// to ensure dark mode logos use 'true' as the 2nd param for getTeamLogo
	let broadcastName, broadcastString;
	let visitingTeamName =
		game.league === 'nba'
			? overrideAllStarsTeamName(game.visiting_team)
			: overrideTeamNameByID(
					game.visiting_team?.id,
					game.league === 'ncaafb'
						? game.visiting_team?.city !== ''
							? game.visiting_team?.city
							: game.visiting_team?.name
						: game.visiting_team?.name
			  );
	let homeTeamName =
		game.league === 'nba'
			? overrideAllStarsTeamName(game.home_team)
			: overrideTeamNameByID(
					game.home_team?.id,
					game.league === 'ncaafb'
						? game.home_team?.city !== ''
							? game.home_team?.city
							: game.home_team?.name
						: game.home_team?.name
			  );
	let visitingTeamLogo =
		game.league === 'nba' && game.type === 'All-Star'
			? 'https://images.sportsnet.ca/general/nba_default.png'
			: getTeamLogo(game.visiting_team, false, ['img_url_59', 'img_url_90', 'image_url_90']);
	let homeTeamLogo =
		game.league === 'nba' && game.type === 'All-Star'
			? 'https://images.sportsnet.ca/general/nba_default.png'
			: getTeamLogo(game.home_team, false, ['img_url_59', 'img_url_90', 'image_url_90']);
	let gameTime = moment.unix(game.timestamp).format('h:mma');
	let gameDate = moment.unix(game.timestamp).format('MMM D');

	let baseballWCTBD =
		game.league === 'mlb' && game.type === 'Post Season' && game.datetime.includes('T04:00:00-04:00') ? true : false;

	if (game.tba === true || game.is_tbd === true || baseballWCTBD === true) {
		gameTime = 'TBD';
	}

	if (game.broadcast?.length > 0) {
		broadcastName = getBroadcastShortName(game.broadcast[0].display_info?.name || game.broadcast[0].name);
		broadcastString = getBroadcastString(game.broadcast[0].display_info?.name || game.broadcast[0].name);
	}

	if (game.visiting_team && !game.visiting_team.short_name) {
		visitingTeamName = 'TBD';
		visitingTeamLogo = defaultLeagueLogo(visitingTeamLogo, game.league);
	}
	if (game.home_team && !game.home_team.short_name) {
		homeTeamName = 'TBD';
		homeTeamLogo = defaultLeagueLogo(homeTeamLogo, game.league);
	}

	const gameLoser =
		game.home_team?.score > game.visiting_team?.score
			? 'visiting'
			: game.visiting_team?.score > game.home_team?.score
			? 'home'
			: null;

	return {
		visitingTeamName,
		visitingTeamLogo: removeSpecialChars(visitingTeamLogo),
		homeTeamName,
		homeTeamLogo: removeSpecialChars(homeTeamLogo),
		broadcastName,
		broadcastString,
		gameLoser,
		gameTime,
		gameDate,
	};
}

export function formaRelativeNumberToPercentage(number, showPercentage = false) {
	let num = parseFloat(number * 100);
	if (Number.isNaN(num)) return '';
	return (num % 1 === 0 ? num : num.toFixed(1)) + (showPercentage ? '%' : '');
}

export function formatDivisionRanksNumericValue(rank) {
	switch (rank) {
		case 1:
			return `${rank}st`;
		case 2:
			return `${rank}nd`;
		case 3:
			return `${rank}rd`;
		default:
			return `${rank}th`;
	}
}

export const calendarLabel = (type, league = '') => {
	switch (type) {
		case 'Spring':
			return `${league.toUpperCase()} Spring Training`;
		case 'Preseason':
			return `${league.toUpperCase()} Pre-Season`;
		default:
			return '';
	}
};

export function usePrevious(value) {
	const ref = useRef();
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
}

export function overrideTeamNameByID(id, name) {
	let newTeamName = '';
	switch (id) {
		case 29082:
			newTeamName = 'Team Hughes';
			break;
		case 5194:
			newTeamName = 'Team MacKinnon';
			break;
		case 5193:
			newTeamName = 'Team Matthews';
			break;
		case 29083:
			newTeamName = 'Team McDavid';
			break;
		default:
			newTeamName = name;
	}

	return newTeamName;
}

export const buildGamePageUrl = game => {
	let url = '';

	switch (game.league) {
		case 'ohl':
		case 'whl':
		case 'qmjhl':
		case 'ahl':
		case 'whc':
		case 'wjc':
		case 'wwhc':
		case 'chl':
			url = `/hockey/${game.league}/games/${game.id}`;
			break;
		case 'oly_mhk':
			url = `/olympics/mens-hockey/games/${game.id}`;
			break;
		case 'oly_whk':
			url = `/olympics/womens-hockey/games/${game.id}`;
			break;
		case 'nhl':
		case 'fournations':
			if (game.is_fournations) {
				url = `/hockey/4nationsfaceoff/games/${game.id}`;
			} else {
				url = `/hockey/nhl/games/${game.id}`;
			}
			break;
		default:
			url = `/${game.sport}/${game.league}/games/${game.id}`;
	}
	return url;
};

export const isStringNumeric = str => {
	return Boolean(str.match(/^[0-9]*$/));
};

/**
 * Returns a new object where specified properties are replaced with default values if they are undefined or null.
 * @param {Object} obj - The object to check and update.
 * @param {Object} defaults - An object specifying default values for certain keys.
 * @returns {Object} - A new object with default values applied.
 */
export function applyDefaultsForNullUndefined(obj, defaults) {
	const newObj = { ...obj };

	for (const key in defaults) {
		if (defaults.hasOwnProperty(key)) {
			if (newObj[key] === undefined || newObj[key] === null) {
				newObj[key] = defaults[key];
			}
		}
	}
	return newObj;
}

export function abbreviateFirstName(firstName, lastName, displayName) {
	const fullName = displayName === undefined ? `${firstName} ${lastName}` : displayName;
	const [initialFirstName, ...rest] = fullName.trim().split(' ');
	return `${initialFirstName.charAt(0).toUpperCase()}. ${rest.join(' ')}`.trim();
}

export const getTeamPageUrl = (isMobileApp, webUrl, deepLinkUrl) => {
	return deepLinkUrl && isMobileApp ? deepLinkUrl : webUrl;
};

export const formatStandingValueWithGamesPlayed = (value, gamesPlayed, replacement) => {
	const number = parseFloat(value);
	const parsedGamesPlayed = parseInt(gamesPlayed);
	if ((isNaN(number) || number === 0) && (isNaN(parsedGamesPlayed) || parsedGamesPlayed === 0)) {
		return replacement;
	}

	return value;
};

export const leagueNameMap = {
	'world-juniors': 'wjc',
	'mens-hockey': 'oly_mhk',
	'womens-hockey': 'oly_whk',
};
export function sortByPlayerElement(a, b) {
	const aValue = a?.props?.children?.[0]?.props?.children || '';
	const bValue = b?.props?.children?.[0]?.props?.children || '';

	return aValue.localeCompare(bValue);
}

export function sortByNumber(a, b) {
	return a - b;
}

export function sortByClock(a, b) {
	try {
		return parseInt(a.replace(':', '')) - parseInt(b.replace(':', ''));
	} catch (e) {
		return 0;
	}
}

export const formatName = (name = '') => {
	return name
		.replace(/[.',\/#!$%\^&\*;:{}=\-_`~()]/g, '') // Remove punctuation
		.replace(/\s+/g, '-') // Replace spaces with hyphens
		.toLowerCase()
		.trim();
};

export function formatPlayerPosition(position) {
	switch (position) {
		case 'Center':
			return 'C';
		case 'Left Wing':
			return 'LW';
		case 'Right Wing':
			return 'RW';
		case 'Defense':
			return 'D';
		case 'Goalie':
			return 'G';
		default:
			return position;
	}
}

export function formatPlayerLink(player, options = {}) {
	const { first_name: firstName, last_name: lastName } = player;
	const playerId = player.id || player.player_id;
	const league = window.location.pathname.split('/')[2];
	const playerUrl = ['nhl', 'mlb', 'nba'].includes(league) ? getPlayerURL(firstName, lastName, playerId) : null;
	
	const playerNameComponent = (
		<>
			<strong>{lastName}</strong>, {firstName}
			{options.position && <span>({formatPlayerPosition(options.position)})</span>}
		</>
	);

	return playerUrl ? <a href={playerUrl}>{playerNameComponent}</a> : <span>{playerNameComponent}</span>;
}
